module.exports = __webpack_public_path__ + "assets/img/logo_naturabisse.d1b2bf90.png";